import React from 'react';
import { Box, Typography } from '@mui/material';
// import Financialreportheader from "./Financialreportheader";
// import Financialreportfooter from "./Financialreportfooter";
// import Financialreporttable from "./FinancialReporttable";
// import { UserListData } from "./UserListData";
// import Financialreportdatepicker from "./Financialreportdatepicker";
// import UserListheader from "./UserListheader";
// import UserListtable from "./UserListtable";
// import Searchbaruserlist from "./Searchbaruserlist";
// import Modaluserlist from "./Modaluserlist";

import Videodetailheader from './Videodetailheader';
import Videodetailtable from './Videodetailtable';

const Videodetail = (props) => {
  const { chapterdetail, setRender, render } = props;
  let chapterdetailitem = chapterdetail;
  let items = chapterdetail?.video;
  console.log("items",items)
  // fetch("https://oakaweapi.herokuapp.com/api/v1/a34jl49u-q4r67p89/courses", {
  //   method: "GET",
  //   credentials: "include",
  //   withCredentials: true,
  //   crossDomain: true,
  //   headers: {
  //     "Access-Control-Allow-Origin": "*",
  //     "Content-Type": "application/json",
  //   },
  //   // mode: 'no-cors',
  // })
  //   .then((response) => response.json())
  //   .then((json) => {
  //     console.log(json);
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   });
  return (
    <>
      <Box
        sx={{
          background: '#fff',
          marginTop: 3,
          borderRadius: 2,
          border: '1px solid #e0e0ef',
        }}
      >
        {/* <Typography sx={{ background: "#F7F7F7",color:'#000',padding:2,borderBottom: "2px solid #F2F2F2",borderTopLeftRadius:8,borderTopRightRadius:8 }}>Financial Report</Typography> */}
        <Box sx={{ padding: 3 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
          </Box>
            <Videodetailheader />
            {/* <Financialreportdatepicker/> */}
            {items?.map((item, index) => (
              <Videodetailtable
                render={render}
                setRender={setRender}
                item={item}
                no={index}
                key={index}
                chapter={chapterdetailitem}
              />
            ))}
        </Box>
      </Box>
    </>
  );
};

export default Videodetail;
